const chartStates = new Map();

// @todo write docs
const plugin = {
  id: 'crosshair',
  beforeInit(chart) {
    chartStates.set(chart, {
      lines: {}
    });
  },
  afterDraw(chart, args, options) {
    const state = chartStates.get(chart);
    const { ctx } = chart;

    Object.values(state.lines).forEach(({ position }) => {
      drawLine(ctx, position, options);
    });
  },
  afterEvent(chart, args, options) {
    const state = chartStates.get(chart);
    const { scales, chartArea } = chart;
    const { event, inChartArea } = args;
    const { display, scales: scaleIDs } = options;

    if (!display || event.type === 'mouseout' || !scaleIDs || scaleIDs.length === 0) {
      if (Object.keys(state.lines).length !== 0) {
        state.lines = {};
        args.changed = true;
      }
    } else if (inChartArea) {
      const defaultPosition = getDefaultPosition(chartArea);

      state.lines = scaleIDs.reduce((acc, scaleID) => {
        const scale = scales[scaleID];
        const horizontal = scale.isHorizontal();
        const value = scale.getValueForPixel(horizontal ? event.x : event.y);

        if (acc[scaleID]?.value !== value) {
          acc[scaleID] = {
            value,
            position: updatePosition(defaultPosition, event, horizontal)
          };
          args.changed = true;
        }

        return acc;
      }, state.lines);
    }
  },
  afterDestroy(chart) {
    chartStates.delete(chart);
  },
  defaults: {
    display: true,
    scales: ({ chart }) => Object.keys(chart.scales),
    borderColor: 'rgba(0,0,0,0)',
    borderWidth: 1,
    borderDash: null
  },
  descriptors: {
    _indexable: false,
    _scriptable: (name) => true
  }
};

export default plugin;

function drawLine(ctx, position, options) {
  const { x1, y1, x2, y2 } = position;
  const { borderColor, borderWidth, borderDash } = options;

  ctx.save();
  ctx.strokeStyle = borderColor;
  ctx.lineWidth = borderWidth;
  ctx.beginPath();
  if (borderDash) {
    ctx.setLineDash(borderDash);
  }
  ctx.moveTo(x1, y1);
  ctx.lineTo(x2, y2);
  ctx.stroke();
  ctx.restore();
}

function getDefaultPosition(chartArea) {
  return {
    x1: chartArea.left,
    y1: chartArea.top,
    x2: chartArea.right,
    y2: chartArea.bottom
  };
}

function updatePosition(position, event, horizontal = false) {
  if (horizontal) {
    return updateXPosition(position, event);
  }

  return updateYPosition(position, event);
}

function updateXPosition(position, event) {
  const { x } = event;

  return {
    ...position,
    x1: x,
    x2: x
  };
}

function updateYPosition(position, event) {
  const { y } = event;

  return {
    ...position,
    y1: y,
    y2: y
  };
}
